import React from 'react';
import { Layout, Menu } from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom'
import { inject } from 'mobx-react';

import { menuConfig, isSubMenu, PATH_TO_KEY, PATH_TO_SUBMENU, MenuConfigItem } from '@/router/menuConfig';

import './Overall.scss'

interface IProps {
  userStore ?: any
}
interface IState {
  collapsed: boolean
}


const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;

@inject((allStores: any) => {
  return {
    userStore: allStores.userStore
  }
})
class Overall extends React.PureComponent<IProps, IState> {
  state = {
    collapsed: !!(window.localStorage && window.localStorage.getItem('collapsed')),
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    }, () => {
      window.localStorage && window.localStorage.setItem('collapsed', this.state.collapsed ? '1' : '');
    });
  };

  componentDidMount() {
    // 初始化一些数据
    this.props.userStore!.getAccount();
  }

  /** 根据配置渲染单个菜单项 */
  renderMenuItem = (item: MenuConfigItem) => {
    if (isSubMenu(item)) {
      return (
        <SubMenu key={item.key} icon={<item.icon />} title={item.label}>
          {item.children.map(child => (
            <Menu.Item key={child.key}>
              <Link to={child.path}>{child.label}</Link>
            </Menu.Item>
          ))}
        </SubMenu>
      );
    }
    return (
      <Menu.Item key={item.key} icon={<item.icon />}>
        <Link to={item.path}>{item.label}</Link>
      </Menu.Item>
    );
  };

  render() {
    // 从 hash URL 中提取路径（去掉 # 号），如 #/new/stock → /new/stock
    const pathname = window.location.hash.slice(1) || '/home';
    const selectedKeys = [PATH_TO_KEY[pathname] || '1'];
    const openKeys = PATH_TO_SUBMENU[pathname] ? [PATH_TO_SUBMENU[pathname]] : [];

    return (
      <Layout>
        <Sider trigger={ null } collapsible collapsed={ this.state.collapsed } 
          style={{
            overflow: 'auto',
            height: '100vh',
          }}>
          <div className="logo" />
          <Menu theme="dark" mode="inline" selectedKeys={ selectedKeys } defaultOpenKeys={ openKeys }>
            { menuConfig.map(this.renderMenuItem) }
          </Menu>
        </Sider>
        <Layout className="site-layout" >
          <Header className="site-layout-background" style={{ paddingLeft: 20 }}>
            {React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger',
              onClick: this.toggle,
            })}
          </Header>
          <Content
            className="site-layout-background"
            style={{
              margin: '24px 16px',
              padding: 24,
              minHeight: 280,
              overflow: 'auto',
              height: 0
            }}
          >
            {
              this.props.children
            }
          </Content>
        </Layout>
      </Layout>
    );
  }
};

export default Overall;
